import { TEMPLATE_FILES, templateHref } from '../templateFile';

export type RunningTemplateLink = {
  label: string;
  href: string;
};

export const IT_DEMAND_FORM = {
  label: 'IT Demand form',
  href: 'https://it-issworld.atlassian.net/servicedesk/customer/portal/134/user/login?destination=portal%2F134%2Fgroup%2F237%2Fcreate%2F439',
} as const;

export const EVALUATION_TEMPLATE_LINKS: Record<
  'evaluationPptx' | 'finalReportDocx',
  RunningTemplateLink
> = {
  evaluationPptx: {
    label: 'PoC Evaluation_template.pptx',
    href: templateHref(TEMPLATE_FILES.evaluationPptx),
  },
  finalReportDocx: {
    label: 'PoC Final Evaluation Report_template.docx',
    href: templateHref(TEMPLATE_FILES.finalReport),
  },
};
